import { render } from "./HoursSettings.vue?vue&type=template&id=363e7b2e"
import script from "./HoursSettings.vue?vue&type=script&lang=js"
export * from "./HoursSettings.vue?vue&type=script&lang=js"

import "./HoursSettings.vue?vue&type=style&index=0&id=363e7b2e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__